// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { formatDistanceToNow } from "date-fns";

import { getDateFnsLocale } from "../../utils/date";
import { CachedFormatFunction } from "./types";

/**
 * Formatter that creates a distance from today string like "(2 months)"
 */
export const formatDistanceFromTodayFormatter: CachedFormatFunction = (
  lng,
  options: { fallbackText?: string },
) => {
  const fallbackText = options.fallbackText ?? "";
  const locale = getDateFnsLocale(lng);

  return (value) => {
    if (!value) return fallbackText;
    const distance = formatDistanceToNow(value, { locale });
    return `${distance}`;
  };
};
